// src/assets/images.js

import logo from "../Assests/images/futureForward_education.png";
import AddUser from "../Assests/images/carbon_manage-protection.png";
import ExportReport from "../Assests/images/lets-icons_export-fill.png";
import AccessManage from "../Assests/images/mingcute_user-add-fill.png";
// import banner from "./banner.jpg";
// import avatar from "./avatar.png";

// Export as a single object
const images = {
  logo,
  AddUser,
  ExportReport,
  AccessManage,
//   banner,
//   avatar,
};

export default images;
